import NestedAccordion from '@salesforce/retail-react-app/app/theme/components/project/nested-accordion'
NestedAccordion.baseStyle = {
    ...NestedAccordion.baseStyle,
    accordionItem: {
        marginRight: 0,
        border: 'none'
    },
    internalButtonIcon: {
        marginRight: 2
    },
    internalButton: {
        main: {
            marginLeft: '1rem',
            width: 'fit-content',
            paddingTop: 4,
            paddingBottom: 4,
            justifyContent: 'space-between'
        },
        text: {
            fontSize: '22px',
            fontWeight: '400',
            marginRight: '10px'
        }
    },
    leafButton: {
        ...NestedAccordion.baseStyle.leafButton,
        width: 'fit-content',
        paddingRight: '0'
    },
    text: {
        fontWeight: 300
    },
    panelSkeleton: {
        container: {
            width: '300px',
            maxWidth: '100%',
            gap: '20px'
        },
        hero: {
            width: 'min(320px, 88vw)',
            height: '170px'
        },
        caption: {
            height: '22px'
        },
        rows: {
            gap: '14px'
        },
        row: {
            height: '18px'
        }
    },
    heading: {
        fontSize: '22px',
        fontWeight: '400',
        color: 'gray.800',
        fontFamily: 'caslon'
    }
}
export default NestedAccordion
